(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('AgendaTranslation', [AgendaTranslationFn]);

    /* prototype for agenda translations */
    function AgendaTranslationFn() {
        var AgendaTranslation = function () {

            this.confirmationEmailText = null;
            this.confirmationSMSText = null;
            this.reminderSMSText = null;
            this.everydayPatientInformation = null;
            this.mandatoryTextInAppointment = null;
            this.onlinePatientInformation = null;
            this.onlineRepresentativesInformation = null;
            this.weekdayPatientInformation = null;
            this.weekendPatientInformation = null;
            this.appointmentMemoCaption = null;
            this.appointmentUserDataCaption = null;
        };

        return AgendaTranslation;
    }
})();